import { noop } from 'lodash';
import { createContext } from 'react';
import { ConfirmModalType } from './constants';

export interface ConfirmModalDataType {
  title: string;
  body: string;
  type: ConfirmModalType;
  confirmButtonText: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export interface ConfirmModalContent {
  modalSettings: ConfirmModalDataType;
  setModalSettings: (obj: ConfirmModalDataType) => void;
  closeModal: () => void;
}

export const initialData = {
  title: '',
  body: '',
  type: ConfirmModalType.DEFAULT,
  confirmButtonText: 'Confirm',
  isOpen: false,
  onCancel: noop,
  onConfirm: noop,
};

export const ConfirmModalContext = createContext<ConfirmModalContent>({
  modalSettings: initialData,
  setModalSettings: noop,
  closeModal: noop,
});
